import type { SVGProps } from 'react'
const SvgSyArrowRightSystem = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path d="m18 10.7-7-7 1.8-1.8L22.9 12 12.8 22.1 11 20.3l7-7H1v-2.6z" />
	</svg>
)
export default SvgSyArrowRightSystem
